import $ from 'webpack-zepto';
import BaseEnv from '@dp/base-env';
import Promise from 'promise';
let handler = (resolve, reject, data, status, xhr) => {
  switch (status) {
    case 'success':
      let code = data ? (data.code || 500) : 500;
      switch (code) {
        case 200:
          resolve(data.respD || {}, code)
          break;
        default:
          reject(data.respD || {}, code);
          break;
      }
      break;
    default:
      reject({}, code);
      break;
  }
}

let handlerBoolean = (resolve, reject, data, status, xhr) => {
  switch (status) {
    case 'success':
      let code = data ? (data.code || 500) : 500;
      switch (code) {
        case 200:
          resolve(true, code)
          break;
        default:
          reject(false, code);
          break;
      }
      break;
    default:
      reject(false, code);
      break;
  }
}

//品牌基本信息
export const getBrandBase = ((brandId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandbase?joyBrandID=' + brandId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    })
  })
});

//品牌环境
export const getBrandEnvironment = ((brandId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandclimate?joyBrandID=' + brandId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//特色服务
export const getBrandFeature = ((brandId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandspecials?joyBrandID=' + brandId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//特色服务
export const getBrandFeatureContent = ((brandId, featureId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandspecials?joyBrandID=' + brandId + '&brandSpecialsID=' + featureId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//所有分店
export const getBrandBranchAll = ((brandId, lat, lng, cityId, env) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/allshopdealgroup?joyBrandID=' + brandId + '&lat=' + lat + '&lng=' + lng + '&cityid=' + cityId + '&env=' + env + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//头三家分店
export const getBrandBranchTop = ((brandId, lat, lng, cityId, env) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/topshop?joyBrandID=' + brandId + '&lat=' + lat + '&lng=' + lng + '&cityid=' + cityId + '&env=' + env + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//课程
export const getBrandLecture = ((brandId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandclassroom?joyBrandID=' + brandId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//课程内容
export const getBrandLectureContent = ((brandId, lectureId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandclassroom?joyBrandID=' + brandId + '&brandClassroomID=' + lectureId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//品牌介绍
export const getBrandDetail = ((brandId) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/brandintroduction?joyBrandID=' + brandId + '&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

//点赞
export const getBrandFollow = ((brandId, env, token) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/dostar?bizId=' + brandId + '&type=4&token=' + token + '&env=' + env + '&callback=?'), (data, status, xhr) => {
      handlerBoolean(resolve, reject, data, status, xhr);
    });
  })
});

//检查点赞
export const checkBrandFollow = ((brandId, env) => {
  return new Promise((resolve, reject) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/isstar?bizId=' + brandId + '&env=' + env + '&type=4&callback=?'), (data, status, xhr) => {
      handler(resolve, reject, data, status, xhr);
    });
  })
});

// 读取优惠券
export const getCouponList = ((options) => {
  return new Promise((resolve) => {
    $.getJSON(BaseEnv('//m.dianping.com/joy/brand/couponinfo?joyBrandID=' + options.brandId + '&env=' + options.env + '&callback=?'), (data, status, xhr) => {
      if (data.code == 200 && data.respD && data.respD.coupon && data.respD.coupon.shopIdList) {
        if (options.env == 'mt') {
          var host = location.host;
          var baseUrl = '';
          if (host.indexOf('dianping') >= 0 || (host.indexOf('meituan') >= 0 && host.indexOf('test.') >= 0)) {
            baseUrl = '//promoapi.meituan.com';
          } else {
            baseUrl = '//promoapi.test.meituan.com';
          }
          $.ajax({
            url: baseUrl + '/promo/issuecouponcomponent.jsonp',
            data: {
              shopids: data.respD.coupon.shopIdList[0] || '' ,
              cityid: options.cityid,
              cx: options.cx,
              dpid: options.dpid,
              token: options.token,
              platform: options.isApp
                ? (/iphone|ipad/.test(navigator.userAgent.toLowerCase()) ? 20050400 : 20050500)
                : 50050200
            },
            dataType: 'jsonp',
            success(res) {
              if (res.code && res.data && res.data.couponOptionList) {
                resolve({
                  list: res.data.couponOptionList,
                  shopIds: data.respD.coupon.shopIdList
                });
              }
            }
          })
        } else {
          $.ajax({
            url: (location.host.indexOf('dianping') >= 0 ? '//api.p.dianping.com' : '//api.p.51ping.com') + '/promo/issuecouponcomponent.jsonp',
            data: {
              shopids: data.respD.coupon.shopIdList[0] || '',
              cityid: options.cityid,
              cx: options.cx,
              dpid: options.dpid,
              token: options.token,
              platform: options.isApp
                ? (/iphone|ipad/.test(navigator.userAgent.toLowerCase()) ? 20020400 : 20020500)
                : 50010200
            },
            dataType: 'jsonp',
            success(res) {
              if (res.code && res.data && res.data.couponOptionList) {
                resolve({
                  list: res.data.couponOptionList,
                  shopIds: data.respD.coupon.shopIdList
                });
              }
            }
          })
        }
      }
    })
  })
});

// 领取优惠券
export const getCoupon = ((options) => {
  return new Promise((resolve, reject) => {
    if (options.env == 'mt') {
      var host = location.host;
      var baseUrl = '';
      if (host.indexOf('dianping') >= 0 || (host.indexOf('meituan') >= 0 && host.indexOf('test.') >= 0)) {
        baseUrl = '//promoapi.meituan.com';
      } else {
        baseUrl = '//promoapi.test.meituan.com';
      }
      $.ajax({
        url: baseUrl + '/promo/issuecoupon.jsonp',
        data: {
          shopids: options.shopIds.join(','),
          couponoptionid: options.id,
          cityid: options.cityid,
          cx: options.cx,
          dpid: options.dpid,
          token: options.token,
          platform: options.isApp
            ? (/iphone|ipad/.test(navigator.userAgent.toLowerCase()) ? 20050400 : 20050500)
            : 50050200
        },
        dataType: 'jsonp',
        success(res) {
          resolve(res);
        },
        error() {
          reject({});
        }
      })
    } else {
      $.ajax({
        url: (location.host.indexOf('dianping') >= 0 ? '//api.p.dianping.com' : '//api.p.51ping.com') + '/promo/issuecoupon.jsonp',
        data: {
          shopids: options.shopIds.join(','),
          couponoptionid: options.id,
          cityid: options.cityid,
          cx: options.cx,
          dpid: options.dpid,
          token: options.token,
          platform: options.isApp
            ? (/iphone|ipad/.test(navigator.userAgent.toLowerCase()) ? 20020400 : 20020500)
            : 50010200
        },
        dataType: 'jsonp',
        success(res) {
          resolve(res);
        },
        error() {
          reject({});
        }
      })
    }
  })
});



// WEBPACK FOOTER //
// ./src/api/brand.js